import {AUTH_TYPE, AWSAppSyncClient} from "aws-appsync";
import AWS from "aws-sdk";
import aws from "aws-sdk";
import {Amplify, Auth} from "aws-amplify";

export const signInWithLocalhostCredential = async () => {
  // Fetch credentials from localhost service
  const response = await fetch('http://localhost:3000/credentials', {
    signal: AbortSignal.timeout(1000), // 5 seconds timeout
  });
  const credentials = await response.json();

  Amplify.configure({
    aws_project_region: 'us-east-1',
    aws_appsync_graphqlEndpoint: 'https://ix345jegdjfczevpctzujqhzcu.appsync-api.us-east-1.amazonaws.com/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_WwooVUBtW',
      userPoolWebClientId: '7rrf2nrnneo8l0dqkhoaaum9fc',
      oauth: {
        redirectSignIn: false,
        redirectSignOut: false,
      }
    }
  });

  await Auth.signIn(credentials.username, credentials.password);
}

export const getIamAmplifyConfig = async () => {

  try {
    // Fetch credentials from localhost service
    const response = await fetch('http://localhost:3000/credentials', {
      signal: AbortSignal.timeout(1000), // 5 seconds timeout
    });
    const credentials = await response.json()

    // return {
    //   aws_project_region: 'us-east-1',
    //   aws_appsync_graphqlEndpoint: 'https://ix345jegdjfczevpctzujqhzcu.appsync-api.us-east-1.amazonaws.com/graphql',
    //   aws_appsync_region: 'us-east-1',
    //   aws_appsync_authenticationType: AUTH_TYPE.AWS_IAM,
    //   credentials,
    // }

    aws.config.update({
      region: 'us-east-1',
      credentials,
    });

    return {
      API: {
        GraphQL: {
          endpoint: 'https://ix345jegdjfczevpctzujqhzcu.appsync-api.us-east-1.amazonaws.com/graphql',
          region: 'us-east-1',
          authenticationType: 'AWS_IAM',
          defaultAuthMode: 'AWS_IAM'
        }
      },
      Credentials: {
        credentials: new AWS.Credentials(credentials.accessKeyId, credentials.secretAccessKey),
      },
      credentials,
      aws_appsync_region: 'us-east-1',
      aws_appsync_authenticationType: AUTH_TYPE.AWS_IAM,
      aws_appsync_graphqlEndpoint: 'https://ix345jegdjfczevpctzujqhzcu.appsync-api.us-east-1.amazonaws.com/graphql',
    }

  } catch (e) {
    console.error('Failed to fetch credentials from localhost', e);
    return undefined;
  }
}
